define(["require", "exports", "jquery", "../facebookApi", "./signup", "../analytics", "./formUtils", "../contiunation"], function (require, exports, $, facebookApi_1, signup_1, analytics_1, formUtils_1, contiunation_1) {
    "use strict";
    exports.__esModule = true;
    var TAG = 'login';
    var Actions;
    (function (Actions) {
        Actions[Actions["prompt"] = 0] = "prompt";
        Actions[Actions["fbLogin"] = 1] = "fbLogin";
        Actions[Actions["emailLogin"] = 2] = "emailLogin";
        Actions[Actions["signup"] = 3] = "signup";
        Actions[Actions["success"] = 4] = "success";
    })(Actions || (Actions = {}));
    function default_1(showCheckoutAsGuest, thenActionName) {
        var $dlg = $('.login-dialog');
        analytics_1["default"](TAG, Actions[Actions.prompt]);
        var host = window.location.hostname;
        var loginUrl = (isLocalDev ? 'http' : 'https') + "://" + window.location.host + "/login";
        if ($dlg.length === 0) {
            var resetPassword = "<a href='/customer/passwordRecovery' class='reset-link'>Forgot password?</a>";
            var emailLogin = "<form action=\"" + loginUrl + "\" method=\"post\"><input type=\"text\" name=\"Email\" placeholder=\"Email\"/><input type=\"password\" name=\"Password\" placeholder=\"Password\"/><input type=\"hidden\" name=\"RememberMe\" value=\"true\"/><button type=\"submit\" class=\"email-login\">Log in</button>" + resetPassword + "</form>";
            var fbLogin = "<button class=\"fb-login\" type=\"button\">Log in with Facebook</button>";
            $dlg = $("<div class=\"login-dialog lock-zoom\">" + emailLogin + "<div class=\"ruler\"><span>or</span><hr/></div>" + fbLogin + "<div class=\"login-footer\"><div><label>Don't have an account?</label><button class=\"signup-link\">Sign up</buton></div></div></div>");
            if (showCheckoutAsGuest) {
                var $submit = $dlg.find('.email-login');
                $('<div class="ruler"><span>or</span><hr/></div><button class="checkout-as-guest" type="button">Checkout as guest</button>').insertAfter($submit);
            }
            $dlg.appendTo($('body'));
            $dlg.find('.fb-login').click(function () {
                analytics_1["default"](TAG, Actions[Actions.fbLogin]);
                $dlg.dialog('close');
                facebookApi_1.logInCeluce(thenActionName);
            });
            $dlg.find('.email-login').click(function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                analytics_1["default"](TAG, Actions[Actions.emailLogin]);
                var $form = $(evt.currentTarget).closest('form');
                $form.find('input:visible').each(function (i, input) {
                    $(input).toggleClass('error', !$(input).val());
                });
                if (showCheckoutAsGuest) {
                    $form.append('<input type="hidden" value="/cart" name="returnUrl"/>');
                }
                else {
                    $form.find('input[name="returnUrl"]').remove();
                }
                if ($form.find('input.error').length === 0) {
                    formUtils_1.appendAntiforgeryToken($form).then(function ($form) {
                        return $.ajax({
                            url: $form.attr('action'),
                            type: 'POST',
                            data: $form.serialize(),
                            dataType: 'json',
                            headers: { 'X-Requested-With': 'XMLHttpRequest' },
                            crossDomain: true,
                            xhrFields: {
                                withCredentials: true
                            }
                        });
                    }).then(function (resp) {
                        if (resp.errors) {
                            $form.find('p.error').remove();
                            $form.prepend($("<p class='error'></p>").text(resp.errors[0].ErrorMessage));
                        }
                        else if (resp && resp.data) {
                            window.location.href = resp.data;
                        }
                        else if (resp && resp.callback) {
                            var fn = window[resp.callback];
                            if (fn) {
                                fn();
                            }
                        }
                        else {
                            console.log(JSON.stringify(resp));
                            contiunation_1.triggerContinuation(contiunation_1.ContinuationTrigger.LOGIN);
                        }
                    });
                }
            });
            $dlg.find('.signup-link').click(function () {
                analytics_1["default"](TAG, Actions[Actions.signup]);
                $dlg.dialog('close');
                signup_1["default"](thenActionName);
            });
            $dlg.find('.checkout-as-guest').click(function () {
                $dlg.dialog('close');
                window.location.href = '/checkout';
            });
        }
        $dlg.dialog('show');
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/login.js
// module id = 7
// module chunks = 0